namespace TabAurous.Inventory {
    export interface SortingDetailsRow {
        TransItemId?: number;
        TransId?: number;
        VoucherTypeId?: number;
        VoucherDate?: string;
        RefVoucherId?: number;
        DepartmentId?: number;
        Line_No?: number;
        BagNo?: string;
        SKU?: string;
        LotNo?: string;
        CertificateNo?: string;
        RefNo?: string;
        RoutingId?: number;
        GroupId?: number;
        ItemTypeId?: number;
        ProductId?: number;
        NewProductId?: number;
        HasBom?: boolean;
        ProductCode?: string;
        ProductName?: string;
        AttributeId?: number;
        ProductTypeName?: string;
        ProductTypeId?: number;
        CategoryId?: number;
        SubCategoryId?: number;
        SieveId?: number;
        QualityId?: number;
        ShapeId?: number;
        StoneColorId?: number;
        StoneSizeId?: number;
        Hsn?: string;
        Studded?: number;
        Pieces?: number;
        Weight?: number;
        NewPieces?: number;
        NewWeight?: number;
        NetWeight?: number;
        CalcOnId?: number;
        UnitRate?: number;
        GrossAmount?: number;
        RefTransItemId?: number;
        RefTransId?: number;
        ImageName?: string;
        Remark?: string;
        SpecialRemark?: string;
        UserDescription?: string;
        AckStatus?: number;
        DeliveryDate?: string;
        CompanyId?: number;
        BagStatus?: string;
        Lab?: string;
        NewSKU?: number;
        StoneSizeName?: string;
        SieveName?: string;
        StoneColoreName?: string;
        QualityName?: string;
        ShapeName?: string;
        ItemsDetails?: SortingItemsRow[];
    }

    export namespace SortingDetailsRow {
        export const idProperty = 'TransItemId';
        export const nameProperty = 'BagNo';
        export const localTextPrefix = 'Inventory.SortingDetails';
        export const deletePermission = 'Inventory:Sorting:Delete';
        export const insertPermission = 'Inventory:Sorting:Add';
        export const readPermission = '*';
        export const updatePermission = 'Inventory:Sorting:Edit';

        export declare const enum Fields {
            TransItemId = "TransItemId",
            TransId = "TransId",
            VoucherTypeId = "VoucherTypeId",
            VoucherDate = "VoucherDate",
            RefVoucherId = "RefVoucherId",
            DepartmentId = "DepartmentId",
            Line_No = "Line_No",
            BagNo = "BagNo",
            SKU = "SKU",
            LotNo = "LotNo",
            CertificateNo = "CertificateNo",
            RefNo = "RefNo",
            RoutingId = "RoutingId",
            GroupId = "GroupId",
            ItemTypeId = "ItemTypeId",
            ProductId = "ProductId",
            NewProductId = "NewProductId",
            HasBom = "HasBom",
            ProductCode = "ProductCode",
            ProductName = "ProductName",
            AttributeId = "AttributeId",
            ProductTypeName = "ProductTypeName",
            ProductTypeId = "ProductTypeId",
            CategoryId = "CategoryId",
            SubCategoryId = "SubCategoryId",
            SieveId = "SieveId",
            QualityId = "QualityId",
            ShapeId = "ShapeId",
            StoneColorId = "StoneColorId",
            StoneSizeId = "StoneSizeId",
            Hsn = "Hsn",
            Studded = "Studded",
            Pieces = "Pieces",
            Weight = "Weight",
            NewPieces = "NewPieces",
            NewWeight = "NewWeight",
            NetWeight = "NetWeight",
            CalcOnId = "CalcOnId",
            UnitRate = "UnitRate",
            GrossAmount = "GrossAmount",
            RefTransItemId = "RefTransItemId",
            RefTransId = "RefTransId",
            ImageName = "ImageName",
            Remark = "Remark",
            SpecialRemark = "SpecialRemark",
            UserDescription = "UserDescription",
            AckStatus = "AckStatus",
            DeliveryDate = "DeliveryDate",
            CompanyId = "CompanyId",
            BagStatus = "BagStatus",
            Lab = "Lab",
            NewSKU = "NewSKU",
            StoneSizeName = "StoneSizeName",
            SieveName = "SieveName",
            StoneColoreName = "StoneColoreName",
            QualityName = "QualityName",
            ShapeName = "ShapeName",
            ItemsDetails = "ItemsDetails"
        }
    }
}
